export default "__VITE_ASSET__BfqJkz7E__"